/* eslint-disable react/no-array-index-key */

import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Row } from '@sainsburys-tech/bolt'
import NavCard from './NavCard.jsx'
import CategoryNavigation from './CategoryNavigation.jsx'
import M005 from '../M005/M005'
import { viewports, breakpoints } from '../../../helpers/ComponentHelper'
import * as Styled from './M012.styles'

/**
 * - M012 is a taxonomy grouping with offers component used by the nav team on smaller screen sizes, from tablet to small mobile.
 * - It can be used with or without offers (M005)
 */
const M012 = (props) => {
  const [viewport, setViewport] = useState('')
  const mql = useRef({})

  const handleResize = () => {
    if (mql.current.matches) {
      setViewport(viewports.SMALL)
    } else {
      setViewport(viewports.MOBILE)
    }
  }

  useEffect(() => {
    mql.current = window.matchMedia(breakpoints.SMALL)
  }, [viewport])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const getCategoryGroup = (categoryGroup) => {
    return categoryGroup.attributes.children.map((item, index) => (
      <NavCard
        dataTest='m012'
        index={index}
        key={item.attributes.name + index}
        name={item.attributes.name}
        image={item.attributes.image}
        type={item.type}
        altText={item.attributes.name}
        linkUrl={item.attributes.path}
        onLinkClick={props.onLinkClick}
      />
    ))
  }

  const offerMatch = (offers, categoryGroupId = null) => {
    const categoryIdMatch = !!categoryGroupId && categoryGroupId.toString()
    const matchingOffers = offers.filter((offer) => categoryIdMatch === offer.subheadingId)

    return offers.map((offer, index) => {
      if (categoryIdMatch === offer.subheadingId && offer.subheadingId !== '') {
        return (
          <M005
            index={index}
            consumingGrid='m012'
            key={index}
            offersLength={matchingOffers.length}
            categoryNavigationView={viewport}
            onLinkClick={props.onLinkClick}
            {...offer}
          />
        )
      }
      // offers without ID and L2
      if (!categoryIdMatch && offer.subheadingId === '') {
        return (
          <M005
            index={index}
            consumingGrid='m012'
            key={index}
            offersLength={props.offers.length}
            categoryNavigationView={viewport}
            onLinkClick={props.onLinkClick}
            {...offer}
          />
        )
      }
      return null
    })
  }

  return (
    <Styled.PaddedRow
      data-test='m012-content-container'
      row='xs'
      hidden={!props.navigation.alwaysShowNavigation ? 'lg' : undefined}
      negative='xs'
      gutterSize='15px'
    >
      {props.navigation.children.map((categoryGroup, index) => {
        const categoryGroupId = categoryGroup.id
        if (categoryGroup.type === 'Sub-Heading') {
          return (
            <CategoryNavigation
              dataTest='m012'
              index={index}
              itemKey={categoryGroup.attributes.name}
              name={categoryGroup.attributes.name}
              key={index}
            >
              {getCategoryGroup(categoryGroup)}
              {props.offers && viewport === viewports.SMALL && offerMatch(props.offers, categoryGroupId)}
              {props.offers && viewport === viewports.MOBILE && (
                <Styled.OffersScroll row='xs' noWrap='xs' xs={12} sm={6} gutterValue={0}>
                  {offerMatch(props.offers, categoryGroupId)}
                </Styled.OffersScroll>
              )}
            </CategoryNavigation>
          )
        }
        return (
          <NavCard
            dataTest='m012'
            index={index}
            key={categoryGroup.attributes.name + index}
            name={categoryGroup.attributes.name}
            image={categoryGroup.attributes.image}
            type={categoryGroup.type}
            altText={categoryGroup.attributes.name}
            linkUrl={categoryGroup.attributes.path}
            onLinkClick={props.onLinkClick}
          />
        )
      })}
      <Row row='xs' xs={12} gutterValue={0}>
        {props.offers && viewport === viewports.SMALL && offerMatch(props.offers)}
        {props.offers && viewport === viewports.MOBILE && (
          <Styled.OffersScroll row='xs' noWrap='xs' xs={12} sm={6} gutterValue={0} gutterSize='30px'>
            {offerMatch(props.offers)}
          </Styled.OffersScroll>
        )}
      </Row>
    </Styled.PaddedRow>
  )
}
M012.propTypes = {
  /** Optional object with children of the categories */
  navigation: PropTypes.object,
  /** Optional array of offers (M005 component/s) */
  offers: PropTypes.array,
  /** Optional function to handle the click on the container  */
  onLinkClick: PropTypes.func
}

M012.defaultProps = {
  navigation: {},
  offers: [],
  onLinkClick: null
}

export default M012
